import { type Optional, ReactUtils } from '@festina-life/core'
import { NavLink } from '@festina-life/ui/actions'
import { Circle } from '@visx/shape'
import cx from 'classnames'
import type { ComponentProps } from 'react'

import {
  ACTIVE_DOT_STROKE,
  DOT_RADIUS,
  INACTIVE_DOT_STROKE,
  INHERITED_DOT_RADIUS,
} from '../versionedTimeline/constants'

type Props = {
  isActive: boolean
  isDraft: boolean
  isInherited: boolean
  isHideVersion?: boolean
  isBeginningOfTime?: boolean
  isLockedToChangeset?: boolean
  to?: Optional<string>
} & ComponentProps<typeof Circle>

export const OperationVersionCircle = ({
  isActive,
  isDraft,
  isInherited,
  isHideVersion = false,
  isBeginningOfTime = false,
  isLockedToChangeset,
  to,
  ...other
}: Props) => {
  const radius = isInherited ? INHERITED_DOT_RADIUS : DOT_RADIUS

  return (
    <ReactUtils.ConditionalWrap
      condition={!!to && !isDraft}
      wrap={(children) => <NavLink to={to!}>{children}</NavLink>}
    >
      <Circle
        r={isActive || isBeginningOfTime ? radius : radius - ACTIVE_DOT_STROKE}
        strokeWidth={
          isActive || isBeginningOfTime
            ? ACTIVE_DOT_STROKE
            : INACTIVE_DOT_STROKE
        }
        className={cx('z-1 hover:opacity-80', {
          'stroke-timeline-dotActive': isActive,
          'stroke-amaze-ink dark:stroke-amaze-inkBright': !isActive,
          'fill-timeline-dot':
            !isDraft &&
            !isLockedToChangeset &&
            !isBeginningOfTime &&
            !isHideVersion,
          'fill-draft-600 dark:fill-draft-400':
            isDraft && !isHideVersion && !isBeginningOfTime,
          'fill-slate-100 dark:fill-amaze-paperDark':
            isHideVersion && !isLockedToChangeset,
          'fill-error-500': isLockedToChangeset,
          'cursor-pointer': !isDraft && !!to,
          'fill-transparent':
            isBeginningOfTime && !isLockedToChangeset && !isHideVersion,
        })}
        {...other}
      />
    </ReactUtils.ConditionalWrap>
  )
}
